import {Operation} from "./Operation.js";
import jStat from "jstat";


export class Stddev extends Operation {

    static displayName() {
        return "Stddev";
    }

    static isNumeric() {
        return true;
    }

    static isCategorical() {
        return false;
    }

    static handlesDate() {
        return false;
    }

    incrementAggregation(newValue) {
        if (this.currValue === null) {
            this.currValue = [];
        }
        this.currValue.push(newValue || 0);
    }

    finish(globalAggregation) {
        if (this.currValue.length < 2) {
            return 0; // Variance is undefined for less than two values
        }
        return jStat.variance(this.currValue, true); // Use population variance
    }
}


export default Stddev;
